import React, {useState, useEffect} from 'react';
import {RouteComponentProps} from 'react-router-dom';
import {withRouter} from 'react-router-dom';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import {ContentHeader} from '@deviceinsight/ng-ui-components';
import {SpinnerContainer} from '@deviceinsight/ng-ui-basic-components';
import {GlobalJob} from './types';
import './types';
import {fetchGlobalJob} from '../../api/updateJobsApi';
import {ADMIN_CREATE_JOB_VARIANT_CONFIGS} from './consts';
import JobVariantDetails from './details/JobVariantDetails';
import GlobalJobDetails from './details/GlobalJobDetails';
import './AdminDetail.less';

type Props = {
	match: {
		params: {
			id: string;
		};
	};
} & RouteComponentProps;

const HEADER_TITLE = {
	id: 'assetgroup.detail.globaljob.title',
	defaultValue: 'Global Job'
};

const GlobalDetail = ({match: {params}}: Props) => {
	const [job, setJob] = useState<GlobalJob | null | undefined>();
	const [loading, setLoading] = useState<boolean>(false);
	useEffect(() => {
		setLoading(true);
		fetchGlobalJob(params.id).then((data) => {
			setJob(data);
			setLoading(false);
		});
	}, [params]);
	return (
		<div className="admin-detail">
			<ContentHeader title={HEADER_TITLE} parentPageLink={true} />
			<SpinnerContainer show={loading}>
				<div className="job-update-detail column-wrapper">
					<div className="job-detail-variants column">
						{Object.keys(ADMIN_CREATE_JOB_VARIANT_CONFIGS).map((key) => {
							const config = ADMIN_CREATE_JOB_VARIANT_CONFIGS[key];
							return (
								<React.Fragment key={key}>
									<h2 className="di header dividing">
										<Trans i18nKey={config.name.id}>{config.name.defaultValue}</Trans>
									</h2>
									<JobVariantDetails
										bundleAndVersionData={
											job ? (job as Record<string, any>)[config.key] : undefined
										}
									/>
								</React.Fragment>
							);
						})}
					</div>
					<div className="job-detail-details column">{job && <GlobalJobDetails job={job} />}</div>
				</div>
			</SpinnerContainer>
		</div>
	);
};

export default withRouter(GlobalDetail);
